<template>
  <v-container>
    <v-row>
      <v-col cols="auto">
        <v-row align="center">
          <v-col cols="auto">
            <h3>{{ $t('serviceBase.currentLocation', { location: '台北' })}}</h3>
          </v-col>
          <v-col cols="auto">
            <info-box label="All Sites" :value="siteCount"></info-box>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto" align-self="center">
        <div class="icon-button" :class="{ 'is-active': currentMode === 'list' }" @click="currentMode = 'list'">
          <v-icon>mdi-menu</v-icon>
        </div>
        <div class="icon-button" :class="{ 'is-active': currentMode === 'map' }" @click="currentMode = 'map'">
          <v-icon>mdi-map</v-icon>
        </div>
      </v-col>
    </v-row>
    <keep-alive>
      <component :is="`${currentMode}-mode`"></component>
    </keep-alive>
  </v-container>
</template>

<script>
import { FAKE_SITE_INFO } from '@/libs/fakeData'
import InfoBox from '@/components/Share/InfoBox'
import MapMode from '@/components/SiteManagement/MapMode'
import ListMode from '@/components/SiteManagement/ListMode'

export default {
  components: { InfoBox, MapMode, ListMode },
  data () {
    return {
      currentMode: 'map',
      siteCount: 285,
      siteInfo: FAKE_SITE_INFO
    }
  }
}
</script>
